export default __webpack_public_path__ + "static/media/photo-4.fbf96b50.jpg";